import { Injectable } from '@angular/core';


import { ToastService } from '@skylab-angular-shared/ui';

import { FiscalDailyReportToastComponent } from './toasts/fiscal-daily-report-toast-component';
import { FiscalMappingErrorToastComponent } from './toasts/fiscal-mapping-error-toast.component';
import { FiscalSuzErrorsToastComponent } from './toasts/fiscal-suz-errors-toast-component';

@Injectable({ providedIn: 'root'})
export class FiscalToastService {
    public constructor(
        private readonly toastService: ToastService
    ) {}

    public showWarning(text: string): void {
        this.toastService.showAsync({
            type: 'warning',
            text,
        });
    }

    public showSuccess(text: string): void {
        this.toastService.showAsync({
            type: 'success',
            text,
        });
    }

    public async showError(text: string, messages?: string[], duration?: number): Promise<void> {
        let dismiss: (() => Promise<void>) | null = null;
        const options = messages?.length ? {
            content: FiscalSuzErrorsToastComponent,
            contentProps: {
                text: text,
                messages: messages,
                dismiss: () => {
                    dismiss?.();
                },
            }
        } : {
            text: text,
        };

        dismiss = await this.toastService.showAsync({
            type: 'error',
            duration,
            ...options
        });
    }

    public async showDailyReport(text: string, messages: string[], callback: () => Promise<void>): Promise<void> {
        const dismiss = await this.toastService.showAsync({
            type: 'error',
            content: FiscalDailyReportToastComponent,
            contentProps: {
                handle: async () => {
                    dismiss();
                    await callback();
                },
                dismiss: () => {
                    dismiss();
                },
                text: text,
                messages: messages || []
            },
            duration: Infinity
        });
    }

    public async showMappingError(text: string, printerId: number, messages: string[]): Promise<void> {
        let dismiss: (() => Promise<void>) | null = null;
 
        dismiss = await this.toastService.showAsync({
            type: 'error',
            duration: Infinity,
            content: FiscalMappingErrorToastComponent,
            contentProps: {
                text, messages, printerId,
                dismiss: () => {
                    dismiss?.();
                },
            }
        });
    }
}
